import * as React from "react";
import { IconProps } from "./types";

export const Recording01Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M3 10L3 14M7.5 6L7.5 18M12 3V21M16.5 6V18M21 10V14"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(Recording01Icon as React.FunctionComponent).displayName = "Recording01Icon";

export default Recording01Icon;
